export default function Logo({ className = "h-20 sm:h-24", testid = "brand-logo" }) {
  return (
    <span className="inline-block rounded-sm">
      <img
        src="/logo.png"
        alt="Redeemer Solutions, LLC — There's always a solution."
        data-testid={testid}
        className={`${className} w-auto`}
      />
    </span>
  );
}
